import { isEmptyParagraph } from '@atlaskit/editor-common/utils';
import { isValidTargetNode, GapCursorSelection } from '@atlaskit/editor-common/selection';
import type { EditorCommand, NextEditorPlugin } from '@atlaskit/editor-common/types';
import { Selection, TextSelection } from '@atlaskit/editor-prosemirror/state';

export type PageTitleUtilsPlugin = NextEditorPlugin<
	'pageTitleUtils',
	{
		dependencies: [];
		commands: {
			selectDocStart: () => EditorCommand;
			insertNewLineAtDocStart: (text?: string) => EditorCommand;
		};
	}
>;

const selectDocStart =
	(): EditorCommand =>
	({ tr }) => {
		const docStartSelection = isValidTargetNode(tr.doc.firstChild)
			? new GapCursorSelection(tr.doc.resolve(0))
			: Selection.atStart(tr.doc);

		tr.setSelection(docStartSelection);

		return tr;
	};

const insertNewLineAtDocStart =
	(): EditorCommand =>
	({ tr }) => {
		if (isEmptyParagraph(tr.doc.firstChild)) {
			return selectDocStart()({ tr });
		}

		const paragraph = tr.doc.type.schema.nodes.paragraph.create();
		tr.insert(0, paragraph);
		tr.setSelection(TextSelection.near(tr.doc.resolve(0)));

		return tr;
	};

export const pageTitleUtilsPlugin: PageTitleUtilsPlugin = () => {
	return {
		name: 'pageTitleUtils',
		dependencies: [],
		commands: {
			selectDocStart,
			insertNewLineAtDocStart,
		},
	};
};
